"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = void 0;
var facebook_1 = require("./facebook");
Object.defineProperty(exports, "Facebook", { enumerable: true, get: function () { return facebook_1.Facebook; } });
//# sourceMappingURL=index.js.map